import customAxios from "../../customAxios";
import { APPROVE_PARENT_TRANSACTION, PAY_ADMIN_DEBT_FACTORS } from "../../routes";

type Props = {
  transactionId?: string;
};

const approveparentTransaction = async (props: Props) => {
  var thisUrl = APPROVE_PARENT_TRANSACTION + "/" + props.transactionId;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ APPROVE_PARENT_TRANSACTION: error });
  }
};

export default approveparentTransaction;
